export default __webpack_public_path__ + "static/media/PictureIcon.98fa0238.svg";